/*
*   联系我们入口
*/
import {Row, Col} from 'antd';
import './css/app.css';

//////////引入组件//////////
import NavMenu from './components/navs/NavMenu';
import Slide from './components/homes/Slide';
import Focus from './components/homes/Focus';
import Footer from './components/footers/Footer';
//////////引入组件//////////
const Contact = (props) => {
    return (
        <div>
            <div className='header'><NavMenu m={props.m}/></div>
            <div className='home'>
                <div className='slide'><Slide /></div>
            </div>
            <div className='content'>
                <Row>
                    <Col offset={4} span={16} style={{ height: '800px', backgroundColor: '#fff' }}>{props.m}</Col>
                </Row>
            </div>
            <div className='focus'><Focus /></div>
            <div className='footer'><Footer /></div>
        </div>
    );
};

export default Contact;